/**
 * Farma Central - Main JavaScript
 * Enhanced animations and interactive behaviors
 */

// Enhanced scroll reveal animation with stagger effect
function initScrollReveal() {
  const observerOptions = {
    threshold: 0.15,
    rootMargin: '0px 0px -80px 0px'
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry, index) => {
      if (entry.isIntersecting) {
        // Add stagger delay for elements in the same container
        const delay = index * 100;
        setTimeout(() => {
          entry.target.classList.add('visible');
        }, delay);
      }
    });
  }, observerOptions);

  // Observe all elements with animation classes
  document.querySelectorAll('.fade-in, .slide-in-left, .slide-in-right, .scale-in').forEach(element => {
    observer.observe(element);
  });
}

// Parallax effect for hero section - DISABLED
function initParallax() {
  // Parallax disabled for fixed hero background
  return;
}

// Animated counter for statistics
function animateCounter(element, target, duration = 2000) {
  let current = 0;
  const increment = target / (duration / 16);
  const timer = setInterval(() => {
    current += increment;
    if (current >= target) {
      current = target;
      clearInterval(timer);
    }
    element.textContent = Math.floor(current);
  }, 16);
}

// Initialize counters when visible
function initCounters() {
  const counters = document.querySelectorAll('[data-count]');
  const counterObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting && !entry.target.classList.contains('counted')) {
        const target = parseInt(entry.target.dataset.count);
        animateCounter(entry.target, target);
        entry.target.classList.add('counted');
      }
    });
  }, { threshold: 0.5 });

  counters.forEach(counter => counterObserver.observe(counter));
}

// Mobile menu toggle - make it globally accessible
window.toggleMobileMenu = function() {
  const menuDropdown = document.querySelector('.mobile-menu-dropdown');
  const menuToggle = document.querySelector('.mobile-menu-toggle');

  if (menuDropdown) {
    menuDropdown.classList.toggle('active');

    if (menuDropdown.classList.contains('active')) {
      menuDropdown.style.display = 'block';
      if (menuToggle && menuToggle.querySelector('i')) {
        menuToggle.querySelector('i').textContent = 'close';
      }
    } else {
      menuDropdown.style.display = 'none';
      if (menuToggle && menuToggle.querySelector('i')) {
        menuToggle.querySelector('i').textContent = 'menu';
      }
    }
  }
}

// Mobile search overlay functions - make globally accessible
window.openMobileSearch = function() {
  const overlay = document.getElementById('mobileSearchOverlay');
  const input = document.getElementById('mobileSearchInput');

  if (overlay) {
    overlay.style.display = 'block';
    document.body.style.overflow = 'hidden'; // Prevent background scrolling

    // Focus on input after a short delay to ensure it's visible
    setTimeout(() => {
      if (input) input.focus();
    }, 100);
  }
}

window.closeMobileSearch = function() {
  const overlay = document.getElementById('mobileSearchOverlay');
  const input = document.getElementById('mobileSearchInput');
  const results = document.getElementById('mobileSearchResults');

  if (overlay) {
    overlay.style.display = 'none';
    document.body.style.overflow = ''; // Restore scrolling

    // Clear search
    if (input) input.value = '';
    if (results) {
      results.innerHTML = `
        <div style="text-align: center; color: #666; padding: 2rem;">
          <div style="display: inline-flex; align-items: center; justify-content: center; margin-bottom: 1rem;">
            <span class="material-icons" style="color: #047cc0; font-size: 64px;">search</span>
          </div>
          <p style="margin: 0;">Escribe para buscar medicamentos</p>
        </div>
      `;
    }
  }
}

// Mobile search functionality
function initMobileSearch() {
  const mobileSearchInput = document.getElementById('mobileSearchInput');
  const mobileSearchResults = document.getElementById('mobileSearchResults');

  if (!mobileSearchInput || !mobileSearchResults) return;

  let searchTimeout;

  mobileSearchInput.addEventListener('input', function(e) {
    clearTimeout(searchTimeout);
    const query = e.target.value.trim();

    if (query.length < 2) {
      mobileSearchResults.innerHTML = `
        <div style="text-align: center; color: #666; padding: 2rem;">
          <div style="display: inline-flex; align-items: center; justify-content: center; margin-bottom: 1rem;">
            <span class="material-icons" style="color: #047cc0; font-size: 64px;">search</span>
          </div>
          <p style="margin: 0;">Escribe al menos 2 caracteres</p>
        </div>
      `;
      return;
    }

    // Show loading state
    mobileSearchResults.innerHTML = `
      <div style="text-align: center; color: #666; padding: 2rem;">
        <div style="display: inline-flex; align-items: center; justify-content: center; margin-bottom: 1rem;">
          <span class="material-icons" style="color: #047cc0; font-size: 64px;">hourglass_empty</span>
        </div>
        <p style="margin: 0;">Buscando...</p>
      </div>
    `;

    searchTimeout = setTimeout(() => {
      fetchMobileSearchResults(query);
    }, 300);
  });
}

async function fetchMobileSearchResults(query) {
  try {
    const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=20`);
    const data = await response.json();

    if (data.resources && data.resources.results && data.resources.results.products) {
      displayMobileSearchResults(data.resources.results.products);
    } else {
      showNoMobileResults();
    }
  } catch (error) {
    console.error('Mobile search error:', error);
    showNoMobileResults();
  }
}

function displayMobileSearchResults(products) {
  const resultsContainer = document.getElementById('mobileSearchResults');

  if (products.length === 0) {
    showNoMobileResults();
    return;
  }

  let html = '<div style="display: flex; flex-direction: column; gap: 1rem;">';

  products.forEach(product => {
    const price = formatMoney(product.price_max || product.price || 0);
    const image = product.image || 'https://images.unsplash.com/photo-1587854692152-cbe660dbde88?q=80&w=200';

    html += `
      <a href="${product.url}" style="display: flex; gap: 1rem; padding: 1rem; background: #f0f8ff; border: 2px solid #e0f2ff; border-radius: 12px; text-decoration: none; color: inherit;">
        <img src="${image}" alt="${product.title}" style="width: 80px; height: 80px; object-fit: cover; border-radius: 8px; border: 2px solid #e0f2ff; flex-shrink: 0;">
        <div style="flex: 1; min-width: 0;">
          <h6 style="color: #16284e; margin: 0 0 0.5rem 0; font-size: 0.95rem; line-height: 1.3;">${product.title}</h6>
          <div style="color: #047cc0; font-weight: 700; font-size: 1rem;">${price}</div>
        </div>
        <div style="display: flex; align-items: center;">
          <i style="color: #047cc0;">arrow_forward</i>
        </div>
      </a>
    `;
  });

  html += '</div>';
  resultsContainer.innerHTML = html;
}

function showNoMobileResults() {
  const resultsContainer = document.getElementById('mobileSearchResults');
  resultsContainer.innerHTML = `
    <div style="text-align: center; color: #666; padding: 2rem;">
      <div style="display: inline-flex; align-items: center; justify-content: center; margin-bottom: 1rem;">
        <span class="material-icons" style="color: #ff9800; font-size: 64px;">search_off</span>
      </div>
      <p style="margin: 0;">No se encontraron productos</p>
    </div>
  `;
}

// Format money helper function
function formatMoney(price) {
  if (!price || isNaN(price)) return '$ 0.00 MXN';
  const formatted = Number(price).toFixed(2);
  return '$ ' + formatted.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' MXN';
}

// Mobile menu toggle
function initMobileMenu() {
  const menuToggle = document.querySelector('.menu-toggle');
  const navMenu = document.querySelector('.nav-menu');

  if (menuToggle && navMenu) {
    menuToggle.addEventListener('click', () => {
      navMenu.classList.toggle('active');
      menuToggle.classList.toggle('active');

      // Animate menu items
      const menuItems = navMenu.querySelectorAll('a');
      menuItems.forEach((item, index) => {
        setTimeout(() => {
          item.style.animation = `fadeInUp 0.5s ease forwards`;
        }, index * 100);
      });
    });
  }
}

// Smooth scroll for anchor links
function initSmoothScroll() {
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const href = this.getAttribute('href');
      if (href !== '#' && href !== '') {
        e.preventDefault();
        const target = document.querySelector(href);
        if (target) {
          const offsetTop = target.offsetTop - 80;
          window.scrollTo({
            top: offsetTop,
            behavior: 'smooth'
          });
        }
      }
    });
  });
}

// Enhanced add to cart animation
function initAddToCart() {
  const addToCartButtons = document.querySelectorAll('.add-to-cart');

  addToCartButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();

      // Create ripple effect
      const ripple = document.createElement('span');
      ripple.style.cssText = `
        position: absolute;
        background: rgba(255, 255, 255, 0.5);
        border-radius: 50%;
        width: 100px;
        height: 100px;
        left: ${e.offsetX - 50}px;
        top: ${e.offsetY - 50}px;
        animation: ripple 0.6s ease-out;
        pointer-events: none;
      `;

      button.style.position = 'relative';
      button.appendChild(ripple);

      setTimeout(() => ripple.remove(), 600);

      // Visual feedback
      const originalText = button.textContent;
      const originalBg = button.style.background;

      button.textContent = '✓ Agregado';
      button.style.background = '#4caf50';
      button.style.transform = 'scale(0.95)';

      setTimeout(() => {
        button.textContent = originalText;
        button.style.background = originalBg;
        button.style.transform = 'scale(1)';
      }, 1500);

      // Animate cart icon
      const cartIcon = document.querySelector('.shopping_cart')?.parentElement;
      if (cartIcon) {
        cartIcon.style.animation = 'bounce 0.5s ease';
        setTimeout(() => {
          cartIcon.style.animation = '';
        }, 500);
      }
    });
  });
}

// Filter functionality with animations
function initFilters() {
  const filterChips = document.querySelectorAll('.filter-chip');
  const productCards = document.querySelectorAll('.product-grid .card');

  filterChips.forEach(chip => {
    chip.addEventListener('click', () => {
      // Remove active from all chips
      filterChips.forEach(c => c.classList.remove('active'));

      // Add active to clicked chip
      chip.classList.add('active');

      // Animate product cards
      productCards.forEach((card, index) => {
        card.style.animation = 'none';
        setTimeout(() => {
          card.style.animation = `fadeInUp 0.5s ease forwards ${index * 0.05}s`;
        }, 10);
      });

      // In a real implementation, this would filter products
      // For prototype, just visual feedback
    });
  });
}

// Image gallery for product page
function initProductGallery() {
  const mainImage = document.querySelector('.product-image-main');
  const thumbnails = document.querySelectorAll('.product-detail img[alt^="Vista"]');

  thumbnails.forEach(thumb => {
    thumb.addEventListener('click', () => {
      // Update main image
      const newSrc = thumb.src.replace(/w=\d+/, 'w=1200');
      mainImage.style.opacity = '0';
      mainImage.style.transform = 'scale(0.95)';

      setTimeout(() => {
        mainImage.src = newSrc;
        mainImage.style.opacity = '1';
        mainImage.style.transform = 'scale(1)';
      }, 200);

      // Update active thumbnail
      thumbnails.forEach(t => {
        t.style.borderColor = '#e0e0e0';
        t.style.borderWidth = '2px';
      });
      thumb.style.borderColor = 'var(--primary)';
      thumb.style.borderWidth = '3px';
    });
  });
}

// Card hover effect with 3D tilt
function init3DCards() {
  const cards = document.querySelectorAll('.card');

  cards.forEach(card => {
    card.addEventListener('mousemove', (e) => {
      const rect = card.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      const centerX = rect.width / 2;
      const centerY = rect.height / 2;

      const rotateX = (y - centerY) / 20;
      const rotateY = (centerX - x) / 20;

      card.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) translateY(-8px) scale(1.02)`;
    });

    card.addEventListener('mouseleave', () => {
      card.style.transform = '';
    });
  });
}

// Navbar scroll effect
function initNavbarScroll() {
  const navbar = document.querySelector('.navbar') || document.querySelector('nav');
  if (!navbar) return;
  
  let lastScroll = 0;

  window.addEventListener('scroll', () => {
    const currentScroll = window.pageYOffset;

    if (currentScroll > 100) {
      navbar.style.backdropFilter = 'blur(20px)';
      navbar.style.boxShadow = '0 4px 30px rgba(0, 0, 0, 0.15)';
    } else {
      navbar.style.backdropFilter = 'blur(10px)';
      navbar.style.boxShadow = '0 2px 20px rgba(0, 0, 0, 0.1)';
    }

    lastScroll = currentScroll;
  });
}

// Price animation
function initPriceAnimations() {
  const prices = document.querySelectorAll('.card-price, .product-price');

  prices.forEach(price => {
    price.addEventListener('mouseenter', () => {
      price.style.transform = 'scale(1.1)';
      price.style.transition = 'transform 0.3s ease';
    });

    price.addEventListener('mouseleave', () => {
      price.style.transform = 'scale(1)';
    });
  });
}

// Floating shapes animation
function initFloatingShapes() {
  const shapes = document.querySelectorAll('.hero-shape');

  shapes.forEach((shape, index) => {
    const randomX = Math.random() * 100;
    const randomY = Math.random() * 100;
    const randomDelay = Math.random() * 3;

    shape.style.left = `${randomX}%`;
    shape.style.top = `${randomY}%`;
    shape.style.animationDelay = `${randomDelay}s`;
  });
}

// Add ripple animation to buttons
function initButtonRipple() {
  const buttons = document.querySelectorAll('.button');

  buttons.forEach(button => {
    button.addEventListener('click', function(e) {
      const ripple = document.createElement('span');
      const rect = this.getBoundingClientRect();
      const size = Math.max(rect.width, rect.height);
      const x = e.clientX - rect.left - size / 2;
      const y = e.clientY - rect.top - size / 2;

      ripple.style.cssText = `
        position: absolute;
        width: ${size}px;
        height: ${size}px;
        left: ${x}px;
        top: ${y}px;
        background: rgba(255, 255, 255, 0.5);
        border-radius: 50%;
        transform: scale(0);
        animation: ripple 0.6s ease-out;
        pointer-events: none;
      `;

      this.style.position = 'relative';
      this.style.overflow = 'hidden';
      this.appendChild(ripple);

      setTimeout(() => ripple.remove(), 600);
    });
  });
}

// Hero Slideshow functionality
let currentSlideIndex = 0;
let slideInterval;

function initHeroSlideshow() {
  const slides = document.querySelectorAll('.slideshow-slide');
  const dots = document.querySelectorAll('.slideshow-dots .dot');

  if (slides.length === 0) return;

  function showSlide(n) {
    currentSlideIndex = n;

    // Hide all slides
    slides.forEach(slide => {
      slide.style.opacity = '0';
    });

    // Remove active class from all dots
    dots.forEach(dot => {
      dot.style.background = 'rgba(255,255,255,0.5)';
      dot.classList.remove('active');
    });

    // Show current slide
    if (slides[currentSlideIndex]) {
      slides[currentSlideIndex].style.opacity = '1';
    }

    // Activate current dot
    if (dots[currentSlideIndex]) {
      dots[currentSlideIndex].style.background = 'white';
      dots[currentSlideIndex].classList.add('active');
    }
  }

  function nextSlide() {
    currentSlideIndex = (currentSlideIndex + 1) % slides.length;
    showSlide(currentSlideIndex);
  }

  // Make currentSlide function globally available
  window.currentSlide = function(n) {
    clearInterval(slideInterval);
    showSlide(n);
    slideInterval = setInterval(nextSlide, 5000);
  };

  // Auto-advance slides every 5 seconds
  slideInterval = setInterval(nextSlide, 5000);

  // Show first slide
  showSlide(0);
}

// Add CSS animations dynamically
const style = document.createElement('style');
style.textContent = `
  @keyframes ripple {
    to {
      transform: scale(4);
      opacity: 0;
    }
  }

  @keyframes bounce {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(-10px); }
  }

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;
document.head.appendChild(style);

// Initialize all functions when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  initScrollReveal();
  initParallax();
  initCounters();
  initMobileMenu();
  initMobileSearch(); // Mobile search overlay
  initSmoothScroll();
  initAddToCart();
  initFilters();
  initProductGallery();
  init3DCards();
  initNavbarScroll();
  initPriceAnimations();
  initFloatingShapes();
  initButtonRipple();
  initProductFilters(); // Collections page product filtering
  initShopifyAddToCart(); // Shopify cart integration
  initHeroSlideshow(); // Hero section slideshow

  // Add loaded class to body for CSS animations
  setTimeout(() => {
    document.body.classList.add('loaded');
  }, 100);
});

// Lazy loading for images with fade-in effect
if ('IntersectionObserver' in window) {
  const imageObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;
        if (img.dataset.src) {
          img.style.opacity = '0';
          img.src = img.dataset.src;
          img.onload = () => {
            img.style.transition = 'opacity 0.5s ease';
            img.style.opacity = '1';
          };
          img.removeAttribute('data-src');
          imageObserver.unobserve(img);
        }
      }
    });
  });

  document.querySelectorAll('img[data-src]').forEach(img => {
    imageObserver.observe(img);
  });
}

// Performance optimization: Debounce scroll events
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// Apply debounce to scroll-intensive functions
window.addEventListener('scroll', debounce(() => {
  // Additional scroll-based animations can go here
}, 50));

// Shopify AJAX cart functionality
async function addToCart(variantId, productName, inventoryQuantity, inventoryManagement, inventoryPolicy) {
  try {
    // Only check inventory if it's managed by Shopify and policy is not "continue" (allow overselling)
    if (inventoryManagement === 'shopify' && inventoryPolicy !== 'continue') {
      const maxInventory = inventoryQuantity !== null && inventoryQuantity !== undefined && inventoryQuantity !== '' ? parseInt(inventoryQuantity) : 0;

      // Get current cart to check if product is already in cart
      const cart = await fetch('/cart.js').then(r => r.json());

      // Find how many of this variant are already in the cart
      let quantityInCart = 0;
      const cartItem = cart.items.find(item => item.variant_id === parseInt(variantId));
      if (cartItem) {
        quantityInCart = cartItem.quantity;
      }

      // Check if adding 1 more exceeds available inventory
      if (quantityInCart + 1 > maxInventory) {
        showToast('No puedes agregar mas unidades de este medicamento a tu carrito', 'error');
        return;
      }
    }

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.description || 'Failed to add to cart');
    }

    const data = await response.json();

    // Get updated cart
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();

    // Update cart count
    const cartBadge = document.querySelector('#cart-count');
    if (cartBadge) {
      cartBadge.textContent = cart.item_count;

      // Animate badge
      cartBadge.style.animation = 'none';
      setTimeout(() => {
        cartBadge.style.animation = 'pulse 0.5s ease';
      }, 10);
    }

    // Animate cart icon
    const cartBtn = document.querySelector('.cart-btn');
    if (cartBtn) {
      cartBtn.style.animation = 'bounce 0.5s ease';
      setTimeout(() => {
        cartBtn.style.animation = '';
      }, 500);
    }

    // Show toast notification
    showToast(`${productName || 'Producto'} agregado al carrito`, 'success');

  } catch (error) {
    console.error('Error adding to cart:', error);
    showToast(error.message || 'Error al agregar al carrito', 'error');
  }
}

// Modal state
let modalProductData = {
  variantId: null,
  productName: '',
  inventoryQuantity: 0,
  inventoryManagement: '',
  inventoryPolicy: '',
  quantityInCart: 0
};

// Open add to cart modal
async function openAddToCartModal(variantId, productName, productImage, inventoryQuantity, inventoryManagement, inventoryPolicy) {
  // Get current cart to check quantity already in cart
  const cart = await fetch('/cart.js').then(r => r.json());
  let quantityInCart = 0;
  const cartItem = cart.items.find(item => item.variant_id === parseInt(variantId));
  if (cartItem) {
    quantityInCart = cartItem.quantity;
  }

  // Store modal data
  modalProductData = {
    variantId,
    productName,
    inventoryQuantity: inventoryQuantity !== null && inventoryQuantity !== undefined && inventoryQuantity !== '' ? parseInt(inventoryQuantity) : 0,
    inventoryManagement,
    inventoryPolicy,
    quantityInCart
  };

  // Update modal content
  document.getElementById('modalProductName').textContent = productName;
  document.getElementById('modalProductImage').src = productImage;
  document.getElementById('modalProductImage').alt = productName;
  document.getElementById('modalQuantityInput').value = '1';

  // Show modal
  const modal = document.getElementById('addToCartModal');
  modal.style.display = 'flex';
}

// Close modal
function closeAddToCartModal() {
  const modal = document.getElementById('addToCartModal');
  modal.style.display = 'none';
  document.getElementById('modalQuantityInput').value = '1';
}

// Update modal quantity
function updateModalQuantity(change) {
  const input = document.getElementById('modalQuantityInput');
  let currentQty = parseInt(input.value);
  let newQty = currentQty + change;

  if (newQty < 1) {
    newQty = 1;
  }

  // Check inventory limits if tracking is enabled
  if (modalProductData.inventoryManagement === 'shopify' && modalProductData.inventoryPolicy !== 'continue') {
    const maxAvailable = modalProductData.inventoryQuantity - modalProductData.quantityInCart;
    if (newQty > maxAvailable) {
      showToast('No puedes agregar mas unidades de este medicamento a tu carrito', 'error');
      return;
    }
  }

  input.value = newQty;
}

// Add to cart and go to cart page
async function addToCartAndGoToCart() {
  const quantity = parseInt(document.getElementById('modalQuantityInput').value);
  const success = await performAddToCart(quantity);
  if (success) {
    window.location.href = '/cart';
  }
}

// Add to cart and keep shopping
async function addToCartAndKeepShopping() {
  const quantity = parseInt(document.getElementById('modalQuantityInput').value);
  const success = await performAddToCart(quantity);
  if (success) {
    closeAddToCartModal();
  }
}

// Perform the actual add to cart
async function performAddToCart(quantity) {
  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: modalProductData.variantId,
        quantity: quantity
      })
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.description || 'Failed to add to cart');
    }

    // Get updated cart
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();

    // Update cart count
    const cartBadge = document.querySelector('#cart-count');
    if (cartBadge) {
      cartBadge.textContent = cart.item_count;

      // Animate badge
      cartBadge.style.animation = 'none';
      setTimeout(() => {
        cartBadge.style.animation = 'pulse 0.5s ease';
      }, 10);
    }

    // Animate cart icon
    const cartBtn = document.querySelector('.cart-btn');
    if (cartBtn) {
      cartBtn.style.animation = 'bounce 0.5s ease';
      setTimeout(() => {
        cartBtn.style.animation = '';
      }, 500);
    }

    // Show success toast
    showToast(`${modalProductData.productName} agregado al carrito`, 'success');
    return true;

  } catch (error) {
    console.error('Error adding to cart:', error);
    showToast(error.message || 'Error al agregar al carrito', 'error');
    return false;
  }
}

// Initialize Shopify add to cart buttons
function initShopifyAddToCart() {
  const addToCartButtons = document.querySelectorAll('.add-to-cart-btn');

  addToCartButtons.forEach(button => {
    button.addEventListener('click', async (e) => {
      e.preventDefault();
      e.stopPropagation();

      const variantId = button.dataset.productId;
      const productCard = button.closest('article');
      const productName = productCard ? productCard.querySelector('h6')?.textContent : 'Producto';

      // Get product image
      const productImage = productCard ? productCard.querySelector('img')?.src : '';

      // Get inventory data
      const inventoryQuantity = button.dataset.inventoryQuantity;
      const inventoryManagement = button.dataset.inventoryManagement;
      const inventoryPolicy = button.dataset.inventoryPolicy;

      // Check if user already has max in cart before opening modal
      if (inventoryManagement === 'shopify' && inventoryPolicy !== 'continue') {
        const maxInventory = inventoryQuantity !== null && inventoryQuantity !== undefined && inventoryQuantity !== '' ? parseInt(inventoryQuantity) : 0;

        // Get current cart
        const cart = await fetch('/cart.js').then(r => r.json());
        let quantityInCart = 0;
        const cartItem = cart.items.find(item => item.variant_id === parseInt(variantId));
        if (cartItem) {
          quantityInCart = cartItem.quantity;
        }

        // If already at max, show error and don't open modal
        if (quantityInCart >= maxInventory) {
          showToast('No puedes agregar mas unidades de este medicamento a tu carrito', 'error');
          return;
        }
      }

      // Open modal
      openAddToCartModal(variantId, productName, productImage, inventoryQuantity, inventoryManagement, inventoryPolicy);
    });
  });
}

// Toast notification (replaced by modal)
function showToast(message, type = 'success') {
  // Check if showNotificationModal function exists (for pages that have the modal)
  if (typeof showNotificationModal === 'function') {
    showNotificationModal(message, type);
    return;
  }

  // Fallback to toast for pages without the modal
  // Remove existing toast if any
  const existingToast = document.querySelector('.toast-notification');
  if (existingToast) {
    existingToast.remove();
  }

  // Create toast element
  const toast = document.createElement('div');
  toast.className = 'toast-notification';

  // Check if mobile
  const isMobile = window.innerWidth <= 768;

  toast.style.cssText = `
    position: fixed;
    bottom: 30px;
    ${isMobile ? 'left: 50%; transform: translateX(-50%); width: calc(100vw - 40px); max-width: 500px;' : 'right: 30px; max-width: 400px;'}
    background: ${type === 'success' ? '#4caf50' : type === 'error' ? '#f44336' : '#047cc0'};
    color: white;
    padding: 16px 24px;
    border-radius: 8px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
    display: flex;
    align-items: center;
    gap: 12px;
    z-index: 10000;
    font-family: 'Manrope', sans-serif;
    font-weight: 600;
    font-size: 0.95rem;
    opacity: 0;
    transition: opacity 0.3s ease;
  `;

  // Add icon
  const icon = document.createElement('i');
  icon.className = 'material-icons';
  icon.textContent = type === 'success' ? 'check_circle' : type === 'error' ? 'error' : 'info';
  icon.style.cssText = 'font-size: 24px;';

  // Add message
  const messageSpan = document.createElement('span');
  messageSpan.textContent = message;

  toast.appendChild(icon);
  toast.appendChild(messageSpan);
  document.body.appendChild(toast);

  // Trigger fade in - use requestAnimationFrame to ensure element is rendered first
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      toast.style.opacity = '1';
    });
  });

  // Remove toast after 3 seconds
  setTimeout(() => {
    toast.style.opacity = '0';
    setTimeout(() => {
      if (toast.parentNode) {
        toast.remove();
      }
    }, 300);
  }, 3000);
}

// Add pulse animation style
const additionalStyles = document.createElement('style');
additionalStyles.textContent = `
  @keyframes pulse {
    0%, 100% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.2);
    }
  }
`;
document.head.appendChild(additionalStyles);

// Collections Page Product Filtering
function initProductFilters() {
  const searchInput = document.getElementById('searchKeyword');
  const specialtyFilter = document.getElementById('specialtyFilter');
  const sortFilter = document.getElementById('sortFilter');
  const clearButton = document.getElementById('clearFilters');
  const productCount = document.getElementById('productCount');
  const productsGrid = document.getElementById('productsGrid');
  const toggleButton = document.getElementById('toggleAdvancedFilters');
  const advancedSection = document.getElementById('advancedFiltersSection');
  const toggleIcon = document.getElementById('filterToggleIcon');

  // Only run if we're on the collections page
  if (!searchInput || !specialtyFilter || !sortFilter) {
    return;
  }

  // Toggle advanced filters
  if (toggleButton && advancedSection && toggleIcon) {
    toggleButton.addEventListener('click', () => {
      const isHidden = advancedSection.style.display === 'none';

      if (isHidden) {
        advancedSection.style.display = 'block';
        toggleIcon.textContent = 'expand_less';
        advancedSection.style.animation = 'fadeInUp 0.3s ease';
      } else {
        advancedSection.style.display = 'none';
        toggleIcon.textContent = 'expand_more';
      }
    });
  }

  // Get all product cards
  let productCards = Array.from(document.querySelectorAll('.product-card'));

  // Filter and sort products
  function filterAndSortProducts() {
    const searchTerm = searchInput.value.toLowerCase().trim();
    const selectedSpecialty = specialtyFilter.value;
    const sortValue = sortFilter.value;

    // Filter products
    let visibleProducts = productCards.filter(card => {
      const name = card.dataset.name.toLowerCase();
      const specialty = card.dataset.specialty;

      // Keyword search
      const matchesSearch = !searchTerm || name.includes(searchTerm);

      // Specialty filter
      const matchesSpecialty = !selectedSpecialty || specialty === selectedSpecialty;

      return matchesSearch && matchesSpecialty;
    });

    // Sort products
    visibleProducts.sort((a, b) => {
      const nameA = a.dataset.name.toLowerCase();
      const nameB = b.dataset.name.toLowerCase();
      const priceA = parseFloat(a.dataset.price);
      const priceB = parseFloat(b.dataset.price);

      switch (sortValue) {
        case 'title-asc':
          return nameA.localeCompare(nameB);
        case 'title-desc':
          return nameB.localeCompare(nameA);
        case 'price-asc':
          return priceA - priceB;
        case 'price-desc':
          return priceB - priceA;
        default:
          return 0; // manual/default order
      }
    });

    // Hide all cards first
    productCards.forEach(card => {
      card.style.display = 'none';
    });

    // Clear and rebuild grid
    productsGrid.innerHTML = '';

    // Show and append filtered/sorted cards with animation
    visibleProducts.forEach((card, index) => {
      card.style.display = 'block';
      card.style.animation = 'none';
      productsGrid.appendChild(card);

      // Trigger reflow
      void card.offsetWidth;

      // Add animation with stagger
      setTimeout(() => {
        card.style.animation = `fadeInUp 0.4s ease forwards`;
      }, index * 50);
    });

    // Update product count
    if (productCount) {
      productCount.textContent = visibleProducts.length;
    }

    // Show "no results" message if needed
    if (visibleProducts.length === 0) {
      const noResults = document.createElement('div');
      noResults.className = 's12';
      noResults.style.cssText = 'text-align: center; padding: 3rem 0;';
      noResults.innerHTML = `
        <i class="material-icons" style="font-size: 64px; color: #047cc0; margin-bottom: 1rem;">search_off</i>
        <h5 style="color: #16284e; margin-bottom: 0.5rem;">No se encontraron productos</h5>
        <p style="color: #666;">Intenta ajustar los filtros de búsqueda</p>
      `;
      productsGrid.appendChild(noResults);
    }
  }

  // Add event listeners
  if (searchInput) {
    searchInput.addEventListener('input', debounce(filterAndSortProducts, 300));
  }

  if (specialtyFilter) {
    specialtyFilter.addEventListener('change', filterAndSortProducts);
  }

  if (sortFilter) {
    sortFilter.addEventListener('change', filterAndSortProducts);
  }

  // Clear filters
  if (clearButton) {
    clearButton.addEventListener('click', () => {
      searchInput.value = '';
      specialtyFilter.selectedIndex = 0;
      sortFilter.selectedIndex = 0;
      filterAndSortProducts();

      // Visual feedback
      clearButton.style.transform = 'scale(0.95)';
      setTimeout(() => {
        clearButton.style.transform = 'scale(1)';
      }, 150);
    });
  }
}
